import portalApi from './axios/portalAxios';

// Stats
export const getAdminStats = () => {
  return portalApi.get('/admin/stats');
};

// Teacher profiles
export const adminCreateTeacherProfile = (data) => {
  return portalApi.post('/admin/teacher-profile', data);
};

export const adminUpdateTeacherProfile = (id, data) => {
  return portalApi.post(`/admin/teachers/${id}`, data);
};

export const getPendingTeachers = (page = 1, perPage = 15, filters = {}) => {
  const params = {
    page,
    per_page: perPage,
  };

  if (filters.search) params.search = filters.search;
  if (filters.subject) params.subject = filters.subject;
  if (filters.date) params.date = filters.date;

  return portalApi.get('/admin/teachers/pending', { params });
};

export const approveTeacher = (id) => {
  return portalApi.patch(`/admin/teachers/${id}/approve`);
};

export const rejectTeacher = (id) => {
  return portalApi.delete(`/admin/teachers/${id}/reject`);
};

// Reviews
export const getAllReviews = () => {
  return portalApi.get('/admin/reviews');
};

export const getReviewById = (id) => {
  return portalApi.get(`/admin/reviews/${id}`);
};

export const getReviewsByTeacherProfileId = (id) => {
  return portalApi.get(`/admin/${id}/reviews`);
};

export const createReviews = (data) => {
  return portalApi.post('/admin/reviews', data);
};

export const updateReview = (id, data) => {
  return portalApi.put(`/admin/reviews/${id}`, data);
};

export const deleteReview = (id) => {
  return portalApi.delete(`/admin/reviews/${id}`);
};

// Recommendations
export const getAllRecommendations = () => {
  return portalApi.get('/admin/recommendations');
};

export const getRecommendationById = (id) => {
  return portalApi.get(`/admin/recommendations/${id}`);
};

export const getRecommendationsByTeacherProfileId = (id) => {
  return portalApi.get(`/admin/${id}/recommendations`);
};

export const createRecommendations = (data) => {
  return portalApi.post('/admin/recommendations', data);
};

export const updateRecommendation = (id, data) => {
  return portalApi.put(`/admin/recommendations/${id}`, data);
};

export const deleteRecommendation = (id) => {
  return portalApi.delete(`/admin/recommendations/${id}`);
};
